import React from 'react';
import PropTypes from 'prop-types';
import RichSelectField from './formfields/RichSelectField'; // Adjust import path as needed

const HourlyPickupSelector = ({ 
  pickupFees, 
  selectedPickupFeeId, 
  onChange,
  className = '',
  placeholder = 'Select pickup time',
  disabled = false 
}) => {
  // Filter for hourly pickup fees and sort by time
  const hourlyPickupOptions = pickupFees
   // .filter(fee => fee.hourly === true)
    .sort((a, b) => a.ready_time_hour - b.ready_time_hour);

  // Format time range for display
  const formatTimeRange = (readyHour, closeHour) => {
    const formatHour = (hour) => {
      if (hour === 0) return '12am';
      if (hour < 12) return `${hour}am`;
      if (hour === 12) return '12pm';
      return `${hour - 12}pm`;
    };
    
    return `${formatHour(readyHour)}-${formatHour(closeHour)}`;
  };

  // Format price for display
  const formatPrice = (priceCents) => {
    return (priceCents / 100).toFixed(2);
  };

  const handleChange = (event) => {
    const { value } = event.target;
    const selectedPickupFee = hourlyPickupOptions.find(fee => fee.id === value);
    
    if (onChange) {
      onChange(selectedPickupFee, value);
    }
  };

  return (
    <div className={`relative ${className}`}>
      <label className="text-xs">Pickup time</label>
      <RichSelectField
        id="hourly-pickup-selector"
        value={selectedPickupFeeId || null}
        options={hourlyPickupOptions}
        useCustomDropdown={true}
        valueKey="id"
        placeholder={placeholder}
        disabled={disabled}
        formatValue={(option) => {
          var label = '';
          if (!option.hourly)
            label =  (`9am-6pm  (+$${formatPrice(option.price_cents)})`)
          else
            label =  option.waived
              ? `${formatTimeRange(option.ready_time_hour, option.close_time_hour)} (Free)`
              : `${formatTimeRange(option.ready_time_hour, option.close_time_hour)} (+$${formatPrice(option.price_cents)})`;

          return {
            key: option?.id,
            icon: null, // No icon for pickup times
            label: label,
            subtitle: ''
          };
        }}
        onChange={handleChange}
        className="text-xs"
      />
    </div>
  );
};

HourlyPickupSelector.propTypes = {
  /** Array of pickup fee objects from the API */
  pickupFees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      fee_type: PropTypes.string,
      sku: PropTypes.string,
      humanized_category: PropTypes.string,
      default: PropTypes.bool,
      ready_time: PropTypes.string,
      close_time: PropTypes.string,
      price_cents: PropTypes.number,
      formatted_amount: PropTypes.string,
      pickup_fees_title: PropTypes.string,
      ready_time_hour: PropTypes.number,
      close_time_hour: PropTypes.number,
      waived: PropTypes.bool,
      hourly: PropTypes.bool.isRequired,
      sameday: PropTypes.bool,
      daily_facility: PropTypes.bool,
    })
  ).isRequired,
  
  /** Currently selected pickup fee ID */
  selectedPickupFeeId: PropTypes.string,
  
  /** 
   * Callback function called when selection changes
   * @param {Object} selectedPickupFee - The selected pickup fee object
   * @param {string} selectedId - The ID of the selected pickup fee
   */
  onChange: PropTypes.func.isRequired,
  
  /** Additional CSS classes */
  className: PropTypes.string,
  
  /** Placeholder text for the select field */
  placeholder: PropTypes.string,
  
  /** Whether the select field is disabled */
  disabled: PropTypes.bool,
};

export default HourlyPickupSelector;